var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-image-upload',{attrs:{"disabled":_vm.sfksc,"isMultiple":"","value":_vm.model.imgUrl.split(',')},on:{"change":_vm.getImg}})}
var staticRenderFns = []

export { render, staticRenderFns }